/*eslint-disable*/
import { extend, localize } from 'vee-validate';
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
} from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';

import {
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorCreditCard, validatorPhoneValidator
} from './validators';

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required);

export const email = extend('email', rule_email);

export const min = extend('min', rule_min);

export const confirmed = extend('confirmed', rule_confirmed);

export const regex = extend('regex', rule_regex);

export const between = extend('between', rule_between);

export const alpha = extend('alpha', rule_alpha);

export const integer = extend('integer', rule_integer);

export const digits = extend('digits', rule_digits);

export const alphaDash = extend('alpha-dash', rule_alpha_dash);

export const alphaNum = extend('alpha-num', rule_alpha_num);

export const length = extend('length', rule_length);

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Please enter positive number!',
});

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!',
});

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit',
});

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
});

export const phoneNumberLength = extend('phoneNumberLength', {
  validate: validatorPhoneValidator,
  message: 'Phone number must be {0} characters long',
});

// Install ru localization.
localize({
  ru: {
    messages: {
      ...ru.messages,
      phoneNumberLength: 'Телефон должен быть длинной в {0} симоволов',
      "confirmed": "Поле {_field_} не совпадает",
    },
    names: {
      email: 'Email',
      password: 'Пароль',
      username: 'Имя пользователя',
      mobile: 'Номер телефона',
      firstname: 'Имя',
      surname: 'Фамилия',
      oldPassword: 'Старый пароль',
      newPassword: 'Новый пароль',
      passwordConfirm: 'Подтверждение пароля',
    },
  },
});
localize('ru');
